import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { assertDefined } from '../../../utils/assertDefined';
import { FETCH_PROJECT_SETTINGS_TRACKER_KEY } from '../consts';

export const waitForProjectSettings = async (client: DynamicClient) => {
  const core = getCore(client);

  const projectSettingsTracker = core.initTrack.getTracker<void>(
    FETCH_PROJECT_SETTINGS_TRACKER_KEY
  );

  assertDefined(projectSettingsTracker, 'Project settings tracker not found');

  await projectSettingsTracker.promise;

  assertDefined(
    client.projectSettings,
    'Project settings still not available after awaiting its tracker'
  );

  return client.projectSettings;
};
